module.exports = __webpack_public_path__ + "img/avatar-27.49c55af9.png";